import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { RoofEmblem } from './RoofEmblem';
const QUOTE_URL = 'https://www.myquickroofquote.com/contractors/texas-direct-roofing-&-construction';
const SESSION_KEY = 'txd_quote_popup_seen';
export function QuotePopup() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (sessionStorage.getItem(SESSION_KEY)) return;
    let fired = false;
    const trigger = () => {
      if (fired) return;
      fired = true;
      setOpen(true);
      window.clearTimeout(timer);
      document.removeEventListener('mouseout', onMouseOut);
    };
    const timer = window.setTimeout(trigger, 8000);
    const onMouseOut = (e: MouseEvent) => {
      // Exit intent: cursor leaves toward the top of the viewport (desktop only)
      if (e.clientY <= 0 && window.innerWidth >= 1024) {
        trigger();
      }
    };
    document.addEventListener('mouseout', onMouseOut);
    return () => {
      window.clearTimeout(timer);
      document.removeEventListener('mouseout', onMouseOut);
    };
  }, []);
  const handleClose = () => {
    setOpen(false);
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch {
      /* ignore */
    }
  };
  return <AnimatePresence data-id="element-220">
      {open && <motion.div className="fixed inset-0 z-[100] flex items-center justify-center p-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} role="dialog" aria-modal="true" aria-labelledby="quote-popup-title" data-id="element-221">
          <div className="absolute inset-0 bg-tx-deep/70 backdrop-blur-sm" onClick={handleClose} data-id="element-222" />

          <motion.div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden" initial={{
        scale: 0.92,
        y: 16,
        opacity: 0
      }} animate={{
        scale: 1,
        y: 0,
        opacity: 1
      }} exit={{
        scale: 0.95,
        opacity: 0
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 26
      }} data-id="element-223">
            <div className="h-2 w-full bg-tx-red" data-id="element-224" />

            <button onClick={handleClose} aria-label="Close" className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-full text-gray-400 hover:text-tx-deep hover:bg-gray-100 transition-colors" data-id="element-225">
              <X className="w-5 h-5" data-id="element-226" />
            </button>

            <div className="p-8 text-center" data-id="element-227">
              <div className="bg-tx-light rounded-2xl p-3 inline-flex mb-5" data-id="element-228">
                <RoofEmblem className="w-14 h-14" data-id="element-229" />
              </div>
              <h3 id="quote-popup-title" className="font-heading text-2xl font-extrabold text-tx-navy tracking-tight mb-3" data-id="element-230">
                Free Roof Quote in 60 Seconds
              </h3>
              <p className="text-gray-600 leading-relaxed mb-7" data-id="element-231">
                Answer a few quick questions and get your estimate. No phone
                call required.
              </p>
              <a href={QUOTE_URL} target="_blank" rel="noopener noreferrer" onClick={handleClose} className="inline-flex w-full items-center justify-center bg-tx-red hover:bg-tx-red/90 text-white font-bold rounded-lg min-h-12 px-6 text-lg transition-colors" data-id="element-232">
                Start My Free Quote
              </a>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}